function DoneMark() {
  return (
    <span
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-eorig-navy-600"
      aria-hidden
    >
      <svg viewBox="0 0 20 20" className="h-5 w-5" fill="none">
        <path
          d="M13.359 8.359a.625.625 0 0 0-.884-.884L8.75 11.2 7.525 9.975a.625.625 0 1 0-.884.884l1.667 1.667a.625.625 0 0 0 .884 0l4.167-4.167Z"
          fill="#FFFFFF"
        />
        <path
          fillRule="evenodd"
          d="M10 1.042A8.958 8.958 0 1 0 10 18.958 8.958 8.958 0 0 0 10 1.042ZM2.292 10A7.708 7.708 0 1 1 17.708 10 7.708 7.708 0 0 1 2.292 10Z"
          fill="#FFFFFF"
        />
      </svg>
    </span>
  );
}

function MissingMark() {
  return (
    <span
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#B02A37]"
      aria-hidden
    >
      <svg viewBox="0 0 20 20" className="h-5 w-5" fill="#FFFFFF">
        <path d="M9.167 5.831h1.666V7.497H9.167V5.831Zm0 3.333h1.666v5H9.167v-5ZM10 1.664a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667Zm0 15a6.667 6.667 0 1 1 0-13.333 6.667 6.667 0 0 1 0 13.333Z" />
      </svg>
    </span>
  );
}

/**
 * Figma evidence-checklist card (UMB eVault 282:48328).
 * `items`: [{ id, label, done }]
 */
export function EvidenceChecklistCard({
  items = [],
  emptyMessage = '0 checklist items returned',
  className = '',
}) {
  const total = items.length;
  const doneCount = items.filter((item) => item.done).length;

  return (
    <section
      aria-label="Evidence checklist"
      className={`rounded-2xl border border-[#E6EAF0] bg-white px-4 py-6 ${className}`.trim()}
    >
      <div className="flex items-center justify-between gap-4">
        <h3 className="text-base font-medium tracking-[-0.0125em] text-[#1F2933]">
          Evidence checklist
        </h3>
        {total > 0 ? (
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#E5F8FC] bg-[#EEF4FF] px-2.5 py-[3px]">
            <span className="h-1.5 w-1.5 rounded-full bg-eorig-cyan" aria-hidden />
            <span className="text-xs font-semibold leading-4 text-eorig-navy-600">
              {doneCount}/{total}
            </span>
          </span>
        ) : null}
      </div>

      {total === 0 ? (
        <p className="mt-4 text-sm text-eorig-muted">{emptyMessage}</p>
      ) : (
        <ul className="mt-4 space-y-3">
          {items.map((item) => (
            <li
              key={item.id}
              className="flex items-center gap-2.5 rounded border border-[#F1F1F1] bg-[#F4F7FA] px-4 py-2.5"
            >
              {item.done ? <DoneMark /> : <MissingMark />}
              <p
                className={`min-w-0 text-sm leading-5 ${
                  item.done ? 'text-[#1F2933]' : 'text-[#B02A37]'
                }`}
              >
                {item.label}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
